import $ from 'jquery';
const eyebrow = document.querySelector('.eyebrow');
const shifty = document.querySelector('.shifty');

export let currentEyebrowHeight = null;
let additionalTimeout;

export function toggleEyebrow (trigger) {
  const eyebrowState = eyebrow.classList.contains('open') ? 'open' : 'closed';
  const target = eyebrow.querySelector(`section.${trigger.getAttribute('data-eyebrow')}`);
  const targetState = target.classList.contains('visible') ? 'visible' : 'not-visible';
  const targetHeight = target.offsetHeight;

  if (targetState === 'visible') {
    // clear all
    eyebrow.querySelectorAll('section').forEach((section) => {
      section.classList.remove('visible');
    });
    // reset height of eyebrow
    // shifty.style.transform = null;
    shifty.style.top = null;
  } else {
    const scrollTop = window.scrollY > targetHeight ? 300 : 0;
    $('html, body').animate({scrollTop: 0}, {
      duration: scrollTop,
      easing: 'linear',
      complete: function () {
        // clear all
        eyebrow.querySelectorAll('section').forEach((section) => {
          section.classList.remove('visible');
        });

        // set height of eyebrow to new content
        // const translate3dPrefixed = window.Modernizr._prefixes.join(`transform: translate3d(0, ${targetHeight}px, 0); `);
        // shifty.style.cssText = translate3dPrefixed;
        // NOTE translate3d changing fixed inheritance I hate you!!!!
        // let shiftUpHeight = targetHeight + trigger.offsetTop;
        shifty.style.top = `${targetHeight}px`;
        // allow itime for eyebrow to open or for a previous target to close
        window.setTimeout(() => {
          target.classList.add('visible');
        }, 500);

        // store the current height
        currentEyebrowHeight = targetHeight;

        // additional actions
        window.clearTimeout(additionalTimeout);

        if (target.querySelector('input[type="text"], input[type="search"], input[type="email"]')) {
          additionalTimeout = setTimeout(function () {
            target.querySelector('input[type="text"], input[type="search"], input[type="email"]').focus();
          }, 1200); // must be longer than transition
        }
      }
    });
  }
}

export function collapseEyebrow (scrollY) {
  // this is instant, no transition, used on scroll listener too 'reset'
  if (currentEyebrowHeight &&
      currentEyebrowHeight < scrollY) {
    eyebrow.querySelectorAll('section').forEach((section) => {
      section.classList.remove('visible');
    });
    shifty.classList.add('instant-transition');
    // shifty.style.transform = null;
    shifty.style.top = null;
    let resetScrollY = scrollY - currentEyebrowHeight;
    document.documentElement.scrollTop = resetScrollY;
    document.body.scrollTop = resetScrollY;
    shifty.classList.remove('instant-transition');

    currentEyebrowHeight = null;
    window.setTimeout(() => {
    }, 50);
  }
}



// WEBPACK FOOTER //
// ./assets/j/src/eyebrow.js